import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link } from 'gatsby';
import Image from 'gatsby-image';

// import { FacebookProvider, Like } from 'react-facebook';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Header from '../components/header';

export const query = graphql`
  query BlogQuery($slug: String!) {
    contentfulBlog(slug: { eq: $slug }) {
      id
      slug
      title
      createdAt
      image {
        id
        file {
          url
        }
        fluid(maxWidth: 750, resizingBehavior: SCALE) {
          ...GatsbyContentfulFluid_tracedSVG
        }
      }
      body {
        json
      }
    }
    allContentfulContacts {
      edges {
        node {
          id
          type
          value
        }
      }
    }
  }
`;

const ArticleTemplate = ({
  data: {
    allContentfulContacts: { edges: rawContacts },
    contentfulBlog: {
      title,
      body: { json: body },
      image,
    },
  },
  location,
}) => {
  const contacts = {};
  // eslint-disable-next-line no-return-assign
  rawContacts.forEach(({ node: { type, value } }) => (contacts[type] = value));

  return (
    <Layout>
      <SEO
        lang="ru"
        title={title}
        keywords={[
          title,
          'блог',
          'статьи',
          'отель',
          'гостевой',
          'дом',
          'hotel',
          'guest',
          'house',
          'dom',
          'yalta',
          'гостевой дом',
          'guest house',
          'dom_yalta',
          'аренда жилья в ялте 2019',
          'отдых в ялте 2019',
          'семейный отдых',
        ]}
        image={image.file.url}
        description={documentToPlainTextString(body).slice(0, 150)}
      />
      <Header contacts={contacts} location={location} sticky />
      <main className="main">
        <div className="pagecontent">
          <div className="container">
            <div className="row flex-wrap">
              <div className="col-xs-12 col-sm-8">
                <div className="content">
                  <div className="title-group">
                    <h1 className="title-1">{title}</h1>
                  </div>
                  <Image className="article-media" fluid={image.fluid} alt={title} />
                  {/* <div className="author-card">
                    <div className="author-thumb">
                      <img src="img/user.jpg" alt="img" className="author-preview" />
                    </div>
                    <div className="author-content">
                      <span className="author-name">Dennis Rice</span>
                      <span className="author-data">12-04-2019</span>
                    </div>
                  </div> */}
                  <div className="article-content">{documentToReactComponents(body)}</div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 sidebar">
                <div className="box-container">
                  <div className="box-content">
                    <div id="yandex_rtb_R-A-599273-4"></div>
                    <script
                      id="gatsby-plugin-yandex-direct"
                      key={`gatsby-plugin-yandex-direct`}
                      dangerouslySetInnerHTML={{
                        __html: `(function(w, d, n, s, t) {
                          w[n] = w[n] || [];
                          w[n].push(function() {
                              Ya.Context.AdvManager.render({
                                  blockId: "R-A-599273-4",
                                  renderTo: "yandex_rtb_R-A-599273-4",
                                  async: true
                              });
                          });
                          t = d.getElementsByTagName("script")[0];
                          s = d.createElement("script");
                          s.type = "text/javascript";
                          s.src = "//an.yandex.ru/system/context.js";
                          s.async = true;
                          t.parentNode.insertBefore(s, t);
                      })(this, this.document, "yandexContextAsyncCallbacks");`
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default ArticleTemplate;
